import { CheckerTOActions } from "./Action";

const initialState = {
  medDetailsForBox: null,
  medDetailsForBoxError: null,
  batchesData: null,
  batchesErr: null,
};

export const checkerTOReducer = (state = initialState, action) => {
  switch (action.type) {
    case CheckerTOActions.FETCH_MED_DETAILS_FOR_BOX_SUCCESS:
      return {
        ...state,
        medDetailsForBox: action.payload,
        medDetailsForBoxError: null,
      };
    case CheckerTOActions.FETCH_MED_DETAILS_FOR_BOX_FAILURE:
      return {
        ...state,
        medDetailsForBox: null,
        medDetailsForBoxError: action.payload,
      };
    case CheckerTOActions.FETCH_BATCH_FOR_BOX_SUCCESS:
      return {
        ...state,
        batchesData: action.payload,
        batchesErr: null,
      };
    case CheckerTOActions.FETCH_BATCH_FOR_BOX_FAILURE:
      return {
        ...state,
        batchesData: null,
        batchesErr: action.payload,
      };

    default:
      return state;
  }
};
